/**
 * 방문예약 코드 관리
 *
 * [사용법]
 *  let value = this.$code.get('service.config.key1');
 *
 * @type {{install: CodeManager.install}}
 */

import axios from 'axios';

const codeMap = {};

async function getPluginInstance() {
    let rootList = [];

    const makeMap = (codeList = null) => {
        codeList = codeList === null ? rootList : codeList;

        codeList.forEach(code => {
            codeMap[code.path] = code.codeValue;
            if (code.children.length > 0) {
                makeMap(code.children);
            }
        })
    };

    try {
        const res = await axios.get("/v1/code/list");

        if (res.data) {
            rootList = [...res.data];
            makeMap();
        }

        return {
            install(Vue) {
                Vue.prototype.$code = {
                    get(key) {
                        return codeMap[key];
                    },

                }
            }
        }
    } catch(err) {
        console.error(err);
    }
}

export default getPluginInstance;